import axios from 'axios';
import apiConfig from '../api.config';

export default function pmsDeleteUdfConfigRequest({ hotelId, udfId }) {
  const {
    host,
    URIs: { pmsConfigHotel },
  } = apiConfig;
  const uri = `${host}${pmsConfigHotel}/${hotelId}/udf/${udfId}`;

  return axios
    .delete(uri, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(res => {
      return res.data;
    });
}
